// modules
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ButtonModule } from '../button/button.module';

// imports
import { Card } from './card.component';
import { CardHeader } from './card-header.component';
import { CardSection } from './card-section.component';
import { CardFooter } from './card-footer.component';

// exports
export {
  Card,
  CardHeader,
  CardSection,
  CardFooter,
};

@NgModule({
  declarations: [
    Card,
    CardHeader,
    CardSection,
    CardFooter,
  ],
  exports: [
    Card,
    CardHeader,
    CardSection,
    CardFooter,
  ],
  imports: [
    CommonModule,
    ButtonModule,
  ]
})
export class CardModule { }
